export default function CTASection() {
  return (
    <section className="relative h-[420px] md:h-[600px] overflow-hidden mx-0">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20still%20life%20composition%20of%20diverse%20curated%20fashion%20and%20lifestyle%20products%20artfully%20arranged%20on%20warm%20cream%20linen%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20above%2C%20clean%20minimal%20aesthetic%2C%20sneakers%20leather%20bags%20knitwear%20ceramics%20spread%20across%20frame%2C%20editorial%20catalog%20style%2C%20harmonious%20warm%20earth%20tones%2C%20sophisticated%20product%20photography%2C%20shallow%20depth%20of%20field%20premium%20presentation&width=1800&height=1000&seq=cta-bg-v2-01&orientation=landscape"
        alt="OOPBUY Spreadsheet Produkt&uuml;bersicht"
        title="OOPBUY Spreadsheet - Dein Shopping Guide"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/30 via-foreground-900/20 to-foreground-900/40"></div>

      <div className="relative h-full container-custom flex flex-col justify-between py-16 md:py-20">
        {/* Top Left - Main Headline */}
        <div>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-none max-w-2xl">
            oopbuy spreadsheet &ndash;<br />dein shopping guide
          </h2>
        </div>

        {/* Bottom area */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          {/* Bottom Left - CTA Button */}
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-7 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer w-fit"
          >
            buy it now
            <span className="w-6 h-6 rounded-full bg-foreground-900 flex items-center justify-center">
              <i className="ri-arrow-right-line text-background-50 text-xs"></i>
            </span>
          </a>

          {/* Bottom Right - Description */}
          <p className="text-base md:text-lg text-background-200 leading-relaxed max-w-sm text-right">
            Tausende Produkte, eine &Uuml;bersicht.<br />Dein direkter Zugang zum vollst&auml;ndigen OOPBUY Spreadsheet.
          </p>
        </div>
      </div>
    </section>
  );
}